var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      {
        staticClass: "button",
        class: _vm.stateClass,
        attrs: { disabled: !!_vm.stateClass }
      },
      _vm.$listeners
    ),
    [
      _c("span", { staticClass: "button__content" }, [_vm._t("default")], 2),
      _c("span", { staticClass: "button__progress" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }